import { graphql } from 'react-relay/legacy.js';

export type {
    pdpRespMarketplaceSecondaryRootQuery$variables,
    pdpRespMarketplaceSecondaryRootQuery as pdpRespMarketplaceSecondaryRootQueryType,
} from './__generated__/pdpRespMarketplaceSecondaryRootQuery.graphql.ts';

export const pdpRespMarketplaceSecondaryRootQuery = graphql`
    query pdpRespMarketplaceSecondaryRootQuery(
        $itemId: String!
        $isTrade: Boolean!
        $itemIds: [String]!
        $fetchUser: Boolean!
        $guestId: String = ""
        $userId: String = ""
        $priceBookName: String = ""
        $afterDisplay: Boolean = false
        $afterDisplayAndBtNone: Boolean = false
        $personalizationId: String = ""
        $userCountryCode: String = ""
        $isEstimateSimilarSoldVariant: Boolean = false
        $isPdpSponsoredMoreSimilarItemsGridVariant: Boolean = false
        $numOfSponsoredItems: Int = 10
        $maxSponsoredItems: Int
        $minSponsoredItemsSteps: [Int!] = [5]
        $isPdpSellerModuleTestVariant: Boolean = false
        $isPdpInfiniteScrollSubModuleVariant: Boolean = false
        $personalizedItemsCount: Int = 10
    ) {
        viewer {
            ...PdpRespMarketplaceLayoutSecondaryRefetchContainer_viewer
        }
    }
`;
